import { createSlice, createAsyncThunk, isAnyOf } from '@reduxjs/toolkit';
import { showToast } from 'Core/redux/toast/slice';
import { closeModal } from 'Core/redux/main/slice';
import { redux } from 'Core/redux';
import { saveAs } from 'Core/utils';
import { MODAL_TYPES } from 'Feature/components/app-modals';
import { CellService } from '../../../service/api/cell-service';
const { CELL_ADD_EDIT } = MODAL_TYPES;

export const STORE_KEY = 'cells';
export const INITIAL_STATE = {
  data: [],
  lanes: [],
  maintenanceData: [],
  machineDetailsData: {},
  machineMaintenanceRecordsData: [],
  machineSafetyChecklistData: [],
  maintenanceRecordsData: [],
  cellHistoryData: [],
  loading: false,
  error: null,
  machine: null,
  printersdata: [],
  filters: {
    status: {
      value: 'In Machine',
      label: 'In Machine',
    },
    searchText: '',
    lane: 'ALL',
  },
  filterVisible: false,
  tileView: true,
  selectedMachine: null,
  editModalVisible: false,
};

export const fetchMachines = createAsyncThunk(
  'cells/fetchMachines',
  async (filters, { rejectWithValue }) => {
    try {
      const response = await CellService.getAllMachinesNew(filters);
      if (response.status === 200) {
        return response.response;
      } else {
        return rejectWithValue(response.errorMessage?.message || 'Failed to load Machines');
      }
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to load Machines');
    }
  },
);

export const fetchLaneNames = createAsyncThunk(
  'cells/fetchLaneNames',
  async ({ rejectWithValue }) => {
    try {
      const response = await CellService.getAllLaneNames();
      if (response.status === 200) {
        return response.response;
      } else {
        return rejectWithValue(response.errorMessage?.message || 'Failed to load lanes');
      }
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to load lanes');
    }
  },
);

export const fetchMachineDetails = createAsyncThunk(
  'cells/fetchMachineDetails',
  async (id, { rejectWithValue }) => {
    try {
      const response = await CellService.getMachineMaintenanceById(id);
      if (response.status === 200) {
        return response.response;
      } else {
        return rejectWithValue(
          response.errorMessage?.message || 'Failed to load Machine Maintenance Details',
        );
      }
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to load Machine  Maintenance Details');
    }
  },
);

export const fetchMachineMaintenanceByAssetNumber = createAsyncThunk(
  'cells/fetchMachineMaintenanceByAssetNumber',
  async (assetNumber, { rejectWithValue }) => {
    try {
      const response = await CellService.getAllMachineMaintenanceByAssetNumber(assetNumber);
      if (response.status === 200) {
        return response.response;
      } else {
        return rejectWithValue(
          response.errorMessage?.message || 'Failed to load All Machine Maintenance Records',
        );
      }
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to load All Machine Maintenance Records');
    }
  },
);

export const fetchMaintenanceRecordsByMachineId = createAsyncThunk(
  'cells/fetchMaintenanceRecordsByMachineId',
  async (machineId, { rejectWithValue }) => {
    try {
      const response = await CellService.getAllMaintenanceRecordsByMachineId(machineId);
      if (response.status === 200) {
        return response.response;
      } else {
        return rejectWithValue(
          response.errorMessage?.message || 'Failed to load Maintenance Records',
        );
      }
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to load Maintenance Records');
    }
  },
);

export const addMachine = createAsyncThunk(
  'cells/addMachine',
  async (machinePayload, { rejectWithValue }) => {
    try {
      const response = await CellService.createMachine(machinePayload);
      if (response.status === 200) {
        return response.response;
      } else {
        return rejectWithValue(response.errorMessage?.message || 'Failed to add Machines');
      }
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to add Machines');
    }
  },
);

export const editMachine = createAsyncThunk(
  'cells/editMachine',
  async (machinePayload, { rejectWithValue }) => {
    try {
      const response = await CellService.createMachine(machinePayload);
      if (response.status === 200) {
        return response.response;
      } else {
        return rejectWithValue(response.errorMessage?.message || 'Failed to update machine');
      }
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to update machine');
    }
  },
);

export const addMachineMaintenanceRecord = createAsyncThunk(
  'cells/addMachineMaintenanceRecord',
  async (machinePayload, { rejectWithValue }) => {
    try {
      const response = await CellService.createMachineMaintenanceAllRecords(machinePayload);
      if (response.status === 200) {
        return response.response;
      } else {
        return rejectWithValue(
          response.errorMessage?.message || 'Failed to add Machine Maintenance All Records',
        );
      }
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to add Machine Maintenance All Records');
    }
  },
);

export const addMachineMaintenanceDetails = createAsyncThunk(
  'cells/addMachineMaintenanceDetails',
  async (machinePayload, { rejectWithValue }) => {
    try {
      const response = await CellService.createMachineMaintenanceDetails(machinePayload);
      if (response.status === 200) {
        return response.response;
      } else {
        return rejectWithValue(
          response.errorMessage?.message || 'Failed to add Machine Maintenance Details',
        );
      }
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to add Machine Maintenance Details');
    }
  },
);
export const addMachineSafetyChecklist = createAsyncThunk(
  'cells/addMachineSafetyChecklist',
  async (machinePayload, { rejectWithValue }) => {
    try {
      const response = await CellService.createMachineSafetyChecklist(machinePayload);
      if (response.status === 200) {
        return response.response;
      } else {
        return rejectWithValue(
          response.errorMessage?.message || 'Failed to add Machine Safety Checklist',
        );
      }
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to add Machine Safety Checklist');
    }
  },
);

export const fetchMaintenanceRecordsDetails = createAsyncThunk(
  'cells/fetchMaintenanceRecordsDetails',
  async ({ maintenanceId, machineId, workOrderNumber }, { rejectWithValue }) => {
    try {
      const response = await CellService.getMaintenanceRecordsDetails(
        maintenanceId,
        machineId,
        workOrderNumber,
      );
      if (response.status === 200) {
        return response.response;
      } else {
        return rejectWithValue(
          response.errorMessage?.message || 'Failed to load Machine Maintenance Details',
        );
      }
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to load Machine  Maintenance Details');
    }
  },
);

export const fetchMachineSafetyChecklist = createAsyncThunk(
  'cells/fetchMachineSafetyChecklist',
  async (machineId, { rejectWithValue }) => {
    try {
      const response = await CellService.getMachineSafetyChecklistByMachine(machineId);
      if (response.status === 200) {
        return response.response;
      } else {
        return rejectWithValue(
          response.errorMessage?.message || 'Failed to load Machine Safety Checklist',
        );
      }
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to load Machine Safety Checklist');
    }
  },
);

export const fetchMachineMaintenance = createAsyncThunk(
  'cells/fetchMachineMaintenance',
  async ({ rejectWithValue }) => {
    try {
      const response = await CellService.getAllMaintenanceRecords();
      if (response.status === 200) {
        return response.response;
      } else {
        return rejectWithValue(
          response.errorMessage?.message || 'Failed to load Machine Maintenace Records',
        );
      }
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to load Machine Maintenance Records');
    }
  },
);

export const downloadMachines = createAsyncThunk(
  'cells/downloadMachines',
  async (filters, { rejectWithValue }) => {
    try {
      const response = await CellService.downloadMachine(filters);
      const blob = response;
      saveAs(blob, `Machines.xlsx`);
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to download Machines');
    }
  },
);

export const deleteMachine = createAsyncThunk(
  'cells/deleteMachine',
  async (machineId, { rejectWithValue }) => {
    try {
      const response = await CellService.deleteMachine(machineId);
      if (response.status === 200) {
        return machineId;
      } else {
        return rejectWithValue(response.errorMessage?.message || 'Failed to delete machine');
      }
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to delete machine');
    }
  },
);

export const fetchMachinesWithFilters = () => (dispatch, getState) => {
  const filters = getState()[STORE_KEY].filters;
  dispatch(
    fetchMachines({
      searchText: filters.searchText,
      id: 0,
    }),
  );
};

export const deleteSafetyChecklist = createAsyncThunk(
  'cells/deleteSafetyChecklist',
  async (id, { rejectWithValue }) => {
    try {
      const response = await CellService.deleteSafetyChecklist(id);
      if (response.status === 200) {
        return id;
      } else {
        return rejectWithValue(
          response.errorMessage?.message || 'Failed to delete safety checklist',
        );
      }
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to delete safety checklist');
    }
  },
);

export const fetchMachineMaintenanceRecords = assetNumber => (dispatch, getState) => {
  dispatch(fetchMachineMaintenance({}));
};

export const fetchMachineSafetyChecklistRecords = machineId => (dispatch, getState) => {
  dispatch(fetchMachineSafetyChecklist(machineId));
};

export const downloadMachinesWithFilters = () => (dispatch, getState) => {
  const filters = getState()[STORE_KEY].filters;
  dispatch(
    downloadMachines({
      searchText: filters.searchText,
      machine: filters?.machine?.value,
      status: filters?.status?.value,
      machineDate: filters?.shipDate,
    }),
  );
};

export const { reducer, actions } = createSlice({
  name: 'cells',
  initialState: INITIAL_STATE,

  lanes: [],
  selectedLane: '',

  reducers: {
    setFilters: (state, action) => {
      state.filters = action.payload;
    },
    setMachine: (state, action) => {
      state.machine = action.payload;
    },
    resetFilters: state => {
      state.filters = INITIAL_STATE.filters;
    },
    setFilterVisible: (state, action) => {
      state.filterVisible = action.payload;
    },
    setLane: (state, action) => {
      state.filters.lane = action.payload;
    },
    setSearchText: (state, action) => {
      state.filters.searchText = action.payload;
    },
    setMachineFilter: (state, action) => {
      state.filters.machine = action.payload;
    },
    setStatus: (state, action) => {
      state.filters.status = action.payload;
    },
    setStartDate: (state, action) => {
      state.filters.startDate = action.payload;
    },
    setEndDate: (state, action) => {
      state.filters.endDate = action.payload;
    },
    setTileView: (state, action) => {
      state.tileView = action.payload;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(fetchMachines.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchMachines.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchMachines.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchLaneNames.fulfilled, (state, action) => {
        state.lanes = ['ALL', ...action.payload];
      })

      .addCase(fetchMachineDetails.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchMachineDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.machineDetailsData = action.payload;
      })
      .addCase(fetchMachineDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchMachineMaintenance.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(fetchMachineMaintenance.fulfilled, (state, action) => {
        state.maintenanceData = action.payload;
        state.loading = false;
      })
      .addCase(fetchMachineMaintenance.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchMachineSafetyChecklist.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(fetchMachineSafetyChecklist.fulfilled, (state, action) => {
        state.machineSafetyChecklistData = action.payload;
        state.loading = false;
      })
      .addCase(fetchMachineSafetyChecklist.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchMaintenanceRecordsDetails.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(fetchMaintenanceRecordsDetails.fulfilled, (state, action) => {
        state.maintenanceRecordsData = action.payload;
        state.loading = false;
      })
      .addCase(fetchMaintenanceRecordsDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(fetchMachineMaintenanceByAssetNumber.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(fetchMachineMaintenanceByAssetNumber.fulfilled, (state, action) => {
        state.cellHistoryData = action.payload;
        state.loading = false;
      })
      .addCase(fetchMachineMaintenanceByAssetNumber.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(fetchMaintenanceRecordsByMachineId.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(fetchMaintenanceRecordsByMachineId.fulfilled, (state, action) => {
        state.machineMaintenanceRecordsData = action.payload;
        state.loading = false;
      })
      .addCase(fetchMaintenanceRecordsByMachineId.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(deleteSafetyChecklist.fulfilled, (state, action) => {
        const newData = state.data.filter(s => s.id !== action.payload);
        state.data = newData;
      })
      .addCase(addMachine.fulfilled, (state, action) => {
        const newMachine = {
          ...action.payload,
          isNewlyCreated: true,
        };
        state.data = [newMachine, ...state.data];
      })
      .addCase(addMachine.rejected, (state, action) => {
        state.error = action.payload;
      })
      .addCase(editMachine.fulfilled, (state, action) => {
        const index = state.data.findIndex(s => s.id === action.payload.id);
        if (index !== -1) {
          state.data[index] = action.payload;
        }
      })
      .addCase(editMachine.rejected, (state, action) => {
        state.error = action.payload;
      })

      .addCase(addMachineMaintenanceDetails.fulfilled, (state, action) => {
        const index = state.data.findIndex(s => s.id === action.payload.id);
        if (index !== -1) {
          state.data[index] = action.payload;
        }
      })
      .addCase(addMachineMaintenanceDetails.rejected, (state, action) => {
        state.error = action.payload;
      })

      .addCase(addMachineSafetyChecklist.fulfilled, (state, action) => {
        const index = state.data.findIndex(s => s.id === action.payload.id);
        if (index !== -1) {
          state.data[index] = action.payload;
        }
      })
      .addCase(addMachineSafetyChecklist.rejected, (state, action) => {
        state.error = action.payload;
      })

      .addCase(addMachineMaintenanceRecord.fulfilled, (state, action) => {
        const index = state.data.findIndex(s => s.id === action.payload.id);
        if (index !== -1) {
          state.data[index] = action.payload;
        }
      })
      .addCase(addMachineMaintenanceRecord.rejected, (state, action) => {
        state.error = action.payload;
      })

      .addCase(deleteMachine.fulfilled, (state, action) => {
        const newData = state.data.filter(s => s.id !== action.payload);
        state.data = newData;
      });
  },
});

redux.listener.startListening({
  matcher: isAnyOf(addMachine.rejected, editMachine.rejected),
  effect: (action, listenerApi) => {
    listenerApi.dispatch(
      showToast({
        message: action.payload,
        type: 'danger',
      }),
    );
  },
});

redux.listener.startListening({
  matcher: isAnyOf(addMachine.fulfilled),
  effect: (action, listenerApi) => {
    listenerApi.dispatch(closeModal(CELL_ADD_EDIT));
    listenerApi.dispatch(
      showToast({
        message: 'Machine saved successfully',
        type: 'success',
      }),
    );
    listenerApi.dispatch(fetchMachinesWithFilters());
  },
});

redux.listener.startListening({
  matcher: isAnyOf(editMachine.fulfilled),
  effect: (action, listenerApi) => {
    listenerApi.dispatch(closeModal(CELL_ADD_EDIT));
    listenerApi.dispatch(
      showToast({
        message: 'Machine updated successfully',
        type: 'success',
      }),
    );
  },
});

redux.listener.startListening({
  matcher: isAnyOf(addMachineMaintenanceDetails.fulfilled),
  effect: (action, listenerApi) => {
    listenerApi.dispatch(closeModal(CELL_ADD_EDIT));
    listenerApi.dispatch(
      showToast({
        message: 'Machine Maintenance Details saved successfully',
        type: 'success',
      }),
    );
     listenerApi.dispatch(fetchMachinesWithFilters());
  },
});

// redux.listener.startListening({
//   matcher: isAnyOf(addMachineMaintenanceDetails.fulfilled),
//   effect: (action, listenerApi) => {
//     listenerApi.dispatch(closeModal(CELL_ADD_EDIT));
//     listenerApi.dispatch(
//       showToast({
//         message: 'Machine Maintenance Details updated successfully',
//         type: 'success',
//       }),
//     );
//   },
// });

redux.listener.startListening({
  matcher: isAnyOf(addMachineSafetyChecklist.fulfilled),
  effect: (action, listenerApi) => {
    listenerApi.dispatch(closeModal(CELL_ADD_EDIT));
    listenerApi.dispatch(
      showToast({
        message: 'Machine Safety Checklist saved successfully',
        type: 'success',
      }),
    );
     listenerApi.dispatch(fetchMachinesWithFilters());
  },
});

// redux.listener.startListening({
//   matcher: isAnyOf(addMachineSafetyChecklist.fulfilled),
//   effect: (action, listenerApi) => {
//     listenerApi.dispatch(closeModal(CELL_ADD_EDIT));
//     listenerApi.dispatch(
//       showToast({
//         message: 'Machine Safety Checklist updated successfully',
//         type: 'success',
//       }),
//     );
//   },
// });

redux.listener.startListening({
  matcher: isAnyOf(addMachineMaintenanceRecord.fulfilled),
  effect: (action, listenerApi) => {
    listenerApi.dispatch(closeModal(CELL_ADD_EDIT));
    listenerApi.dispatch(
      showToast({
        message: 'Machine Maintenance Record saved successfully',
        type: 'success',
      }),
    );
      listenerApi.dispatch(fetchMachinesWithFilters());
  },
});

// redux.listener.startListening({
//   matcher: isAnyOf(addMachineMaintenanceRecord.fulfilled),
//   effect: (action, listenerApi) => {
//     listenerApi.dispatch(closeModal(CELL_ADD_EDIT));
//     listenerApi.dispatch(
//       showToast({
//         message: 'Machine Maintenance Record updated successfully',
//         type: 'success',
//       }),
//     );
//   },
// });

// redux.listener.startListening({
//   matcher: isAnyOf(addMachine.fulfilled),
//   effect: (action, listenerApi) => {
//     listenerApi.dispatch(closeModal(CELL_ADD_EDIT));
//     listenerApi.dispatch(
//       showToast({
//         message: 'Machine saved successfully',
//         type: 'success',
//       }),
//     );
//   },
// });

redux.listener.startListening({
  matcher: isAnyOf(deleteMachine.fulfilled),
  effect: (action, listenerApi) => {
    listenerApi.dispatch(
      showToast({
        message: 'Machine deleted successfully',
        type: 'success',
      }),
    );
  },
});

redux.listener.startListening({
  matcher: isAnyOf(deleteSafetyChecklist.fulfilled),
  effect: (action, listenerApi) => {
    listenerApi.dispatch(
      showToast({
        message: 'Safety Checklist deleted successfully',
        type: 'success',
      }),
    );
  },
});

redux.injectReducer(STORE_KEY, reducer);
